import LoadingText from '../../components/LoadingText'
import type { LoadableComponentProps } from '../../types'

interface ClubPointsHistoryProps {
  title: string
  points: number
  currentPointsLabel: string
  pointsLabel: string
  ordersLabel: string
  pointsAddedLabel: string
  noOrdersLabel: string
  orders: {
    date: string
    points: number
  }[]
}

export default function ClubPointsHistory({
  data,
  loading,
}: LoadableComponentProps<ClubPointsHistoryProps>) {
  const {
    title,
    currentPointsLabel,
    pointsLabel,
    ordersLabel,
    points,
    noOrdersLabel,
    orders,
    pointsAddedLabel,
  } = data || {}

  return (
    <div
      className='isolate mx-auto w-full px-5 py-10'
      style={{
        maxWidth: 'var(--layout-max-width, none)',
      }}
    >
      <h2 className='h5 mb-6'>
        {loading ? <LoadingText className='inline' textLength={15} /> : title}
      </h2>
      <p className='sm'>
        {loading ? <LoadingText className='inline' textLength={10} /> : currentPointsLabel}
      </p>
      <p className='sm mb-6 font-bold text-highlight' data-testid='club-history-current-points'>
        {loading ? <LoadingText className='inline' textLength={5} /> : points}
      </p>
      <div className='radius-md w-full divide-y divide-solid divide-gray/35 bg-ecruwhite px-3 md:px-5 lg:rounded-md'>
        {loading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <div className='flex justify-between py-5' key={index}>
              <div>
                <p className='mb-1'>
                  <LoadingText className='inline' textLength={10} />
                </p>
                <p>
                  <LoadingText className='inline' textLength={15} />
                </p>
              </div>
              <div>
                <p className='sm font-bold text-highlight'>
                  <LoadingText className='inline' textLength={5} />
                </p>
                <p className='sm text-darkgray'>
                  <LoadingText className='inline' textLength={10} />
                </p>
              </div>
            </div>
          ))
        ) : orders && orders.length > 0 ? (
          orders.map((order, index) => (
            <div
              data-testid={`order-${index}`}
              className='flex justify-between py-5'
              key={order.date}
            >
              <div>
                <p className='mb-1'>{ordersLabel}</p>
                <p>{order.date}</p>
              </div>
              <div>
                <p className='sm font-bold text-highlight'>
                  {'+ ' + order.points + ' ' + pointsLabel}
                </p>
                <p className='sm text-darkgray'>{pointsAddedLabel}</p>
              </div>
            </div>
          ))
        ) : (
          <div data-testid='no-orders-label' className='flex justify-center py-5'>
            <p className='sm text-darkgray'>{noOrdersLabel}</p>
          </div>
        )}
      </div>
    </div>
  )
}
